export const loginUrl = "https://api.shc.gov.sa/api/auth/login"
export const getStatsUrl = "https://api.shc.gov.sa/api/dashboard/statistics"
export const getFormsUrl = "https://api.shc.gov.sa/api/dashboard/getRecords"
export const deleteRecordUrl = "https://api.shc.gov.sa/api/dashboard/deleteRecord"
export const clientRecordUrl = "https://api.shc.gov.sa/api/clientRecord"
export const downloadExcel = "https://api.shc.gov.sa/api/dashboard/download-data"
export const deleteAdminUrl = "https://api.shc.gov.sa/api/admin/deleteAdmin?id="
export const getAdmins = "https://api.shc.gov.sa/api/admin/getAdmins"
export const createAdminUrl = "https://api.shc.gov.sa/api/admin/createAdmin"
export const updateAdminUrl = "https://api.shc.gov.sa/api/admin/updateAdmin"